/**
 * Tooltip copy for a related-term / plural chip, based on which side it sits on,
 * whether it's currently selected, and whether it's in a both-sides conflict.
 *
 * Only selected chips get a tooltip. A plain included chip (selected, no conflict)
 * returns null — no tooltip needed. Exclusion chips explain that matching results
 * are removed; a both-sides conflict shows the same neutral message on either half.
 *
 * Copy per Product (Romeo, SCIL-16099). The provenance suffix (— from related term /
 * plural / spelling variant) and quote style are still being finalised.
 *
 * @param {object} args
 * @param {string} args.label - chip text as displayed
 * @param {boolean} args.excluded - chip sits under an exclusion-side parent term
 * @param {boolean} args.selected - chip is currently on
 * @param {boolean} args.conflicted - selected on both an include and an exclude side
 * @returns {string|null}
 */
export function chipStateTooltip({ label, excluded, selected, conflicted }) {
  if (!selected) return null;

  if (conflicted) {
    return `"${label}" is both included and excluded. Exclude takes priority, so it's filtered out.`;
  }

  if (excluded) {
    return `Results mentioning "${label}" will be excluded.`;
  }

  return null;
}

/**
 * Tooltip copy for a Stage-2 review chip carrying a Lucene proximity ("slop") phrase,
 * explaining what the `~N` value means for the words in that phrase.
 *
 * @param {string} phrase - the phrase text, without the `Proximity:` chip label prefix
 * @param {string|number} distance - the slop value, e.g. `9`
 * @returns {string}
 */
export function proximityReviewTooltip(phrase, distance) {
  return `Matches when the words in "${phrase}" appear within ${distance} words of each other, in any order.`;
}
